import * as React from "react";
import { useEffect, useState } from "react";
import KitsConfiguration from "./KitsConfiguration";
import  ProjectService  from "src/app/project/ProjectService";
import {setQueryParam} from 'src/app/polar-SAAS-Components/utilsNew';
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import  authService  from "src/app/polar-SAAS-Components/auth-service";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";

export default function CorporateProfileConfig() {
  const [activeTab, setActiveTab] = useState("Kits Configuration");
  const [showUserLevelPopup, setShowUserLevelPopup] = useState(false);
  const [showAlertLevelPopup, setShowAlertLevelPopup] = useState(false);
  const [maintenanceUserLevelCount, setMaintenanceUserLevelCount] = useState(1);
  const [alertLevelCount, setAlertLevelCount] = useState(1);
  const [projectUpdates, setProjectUpdates] = useState({
    maintainLevel: false,
    maxNoofAlerts: false,
    offlineCount: false,
    dataInterval: false,
    userAlertLevel: false
  });
  const [loading,setLoading]=useState(false);
  const initialUserLevels =
   authService && authService.isCorporateSAASAdmin()
    ? [ { id: 101, role: "SAAS Admin", alertLevel: "" } ]
    : [
        { id: 100, role: "Corporate Admin", alertLevel: "" },
       {...!authService.isAzureUser()&&{ id: 1000, role: "Project Admin", alertLevel: "" }},
        { id: 2000, role: "Maintenance Level 1", alertLevel: "" },
        { id: 10000, role: "KitUser", alertLevel: "" },
      ];
  
  
  const [userLevels, setUserLevels]=useState(initialUserLevels)

  const [openToaster,setopenToaster]=useState(false);
  const [msg,setMsg]=useState("");
  const [success,setSuccess]=useState(true);

  const [advancedSettings, setAdvancedSettings] = useState({
    dataInterval: "",
    offlineAlertAfter: "",
    maxContinuesAlerts: "",
  });


  const [projectsForUser, setProjectsForUser] = useState([]);
  const [error,setError] = useState({});
  const [projectId,setProjectId]=useState("")

  const tabs = ["Project Configuration", "Kits Configuration"];
  const maintenanceLevels = [1, 2, 3, 4, 5];
  const alertLevelOptions = [1, 2, 3, 4, 5];
  const projectService = new ProjectService();

  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get("type");
  const id = queryParams.get("id");
      const isMobile = useIsMobile(768);
  
  useEffect(() => {


    if (authService.hasProjectManagementAccess() && type === "project") {
           setActiveTab("Project Configuration"); 
    } else{
           setActiveTab("Kits Configuration");
    } 

    
        // Fetch kits for the user and update state
        const fetchProjects = async () => {
          const response = await ProjectService.getProjectsForUser();
          console.log("Projects fetched:", response);
          if (response.status === 200 && response.data.content) {
            
            setProjectsForUser(response.data.content);
            setError({ error: false, message: "" });
          }
          else if (response.status == 422) {
            setError({ error: true, message: response.data.message || "Failed to get Projects" });
            setProjectsForUser([]);
          }
          else {
            setError({ error: true, message: response.data.message || "Failed to get Projects" });
            setProjectsForUser([]);
          }}   
       if(type!=="kit"){
         try {
           setLoading(true);
           fetchProjects();
         }
         catch (error) {
           
           console.log('error fetching projects for user', error)
         }
         finally {
           setLoading(false);
         }
        if (id) {
          setProjectId(id);
          getProject(id);}
        }
  }, [type]);


const handleUserLevelChange = (id, level) => {
  const updatedLevels = userLevels.map(userLevel =>
    userLevel.id === parseInt(id)
      ? { ...userLevel, alertLevel: level } 
      : userLevel 
  );

  console.log("updated", updatedLevels);
  setUserLevels(updatedLevels);
  setProjectUpdates(prev=>({...prev,userAlertLevel:true}))
};
  const handleSetAlertLevelCount =async(updateLevel)=>{
       try{
      const response=await projectService.updateProject(projectId, { alertLevel: updateLevel});
      console.log('maintenance',response)
      if (response.status===200){
        console.log('update ' )
        console.log(updateLevel)
           setAlertLevelCount(parseInt(updateLevel));
      }
    }
    catch(error){
      console.log('error updating maintenance ',error)
    }


      setProjectUpdates(prev=>({...prev,maxNoofAlerts:true}))
  }
  const handleUpdateMaintainUserLevel = async(updateLevel) => {
   
   try{
      const response=await projectService.updateProject(projectId, { maintainLevel: updateLevel});
      console.log('maintenance',response)
      if (response.status===200){
        console.log('update ' )
        console.log(updateLevel)
        updateMaintainLevels(userLevels,updateLevel)
        setMaintenanceUserLevelCount(updateLevel);
      }
    }
    catch(error){
      console.log('error updating maintenance ',error)
    }

   
  };
  const handleChangeActiveTab = (tab) => {
    setActiveTab(tab);
    const newUrl = `${window.location.pathname}?type=${tab === "Project Configuration" ? "project" :  "kit" }`;
    window.history.replaceState({}, '', newUrl);
  }

  const handleAdvancedSettingChange = (field, value) => {
    setAdvancedSettings((prev) => ({ ...prev, [field]: value }));
    setProjectUpdates(prev=>({...prev,[field]:true}))
  };



const handleSave = async () => {
  try {
    let projectDatasToUpdate:any = {};
    console.log('to save update ddata',projectUpdates)
    // Only add properties that have been changed
    if (projectUpdates.dataInterval) {
      projectDatasToUpdate.dataInterval = advancedSettings.dataInterval;
    }
    if (projectUpdates.maxNoofAlerts) {
      projectDatasToUpdate.maxNoofAlerts = advancedSettings.maxContinuesAlerts;
    }
    if (projectUpdates.offlineCount) {
      projectDatasToUpdate.offlineCount = advancedSettings.offlineAlertAfter;
    }
    
    // Handle user alert levels if changed
    if (projectUpdates.userAlertLevel) {
      const userLevelsToUpdate = {};
      userLevels.forEach(level => {
        if (level.alertLevel ) {
          userLevelsToUpdate[level.id] = parseInt(level.alertLevel);
        }
      });
      
      if (Object.keys(userLevelsToUpdate).length > 0) {
        projectDatasToUpdate.userAlertLevel = userLevelsToUpdate;
      }
    }

    // Only proceed if there are actual updates to make
    if (Object.keys(projectDatasToUpdate).length > 0) {
      console.log("Updating project with data:", projectDatasToUpdate);
      setLoading(true);
      const response = await projectService.updateProject(projectId, projectDatasToUpdate);
      
      if (response.status === 200) {
        console.log("Project updated successfully");
        setLoading(false);
        setMsg("Project Configurations updated successfully");
        setopenToaster(true);
        setTimeout(function() {
          setopenToaster(false);
        }, 5000);
        
        // Reset the update flags
        setProjectUpdates({
          maintainLevel: false,
          maxNoofAlerts: false,
          offlineCount: false,
          dataInterval: false,
          userAlertLevel: false
        });
        // Refresh project data
        await getProject(projectId);
      }
    }
  } catch (error) {
    setLoading(false)
    console.error("Error updating project:", error);
    // Handle error appropriately
  }
};
  const getProject=async(id)=>{
        setLoading(true);
    try {
      const response = await projectService.getProject( id);
      console.log("project fetched:", response);
      const project = response.data.content;
      // setAlertCountSettings();
      setAdvancedSettings({
        dataInterval:String(project.dataInterval),
        offlineAlertAfter:project.offlineCount,
        maxContinuesAlerts:project.maxNoofAlerts
      })
      setMaintenanceUserLevelCount(project.maintainLevel);
      initiateMaintainLevels(project.userAlertLevel,project.maintainLevel);
      setAlertLevelCount(project.alertLevel)

     
      

      
    } catch (err) {
      console.error('error fetching project properties',err);
    } finally {
      setLoading(false);
    }
  }
    const handleProjectSelect = ( value) => {
      setProjectId(value);
      setQueryParam("id", value);
      getProject(value);
    };
  const initiateMaintainLevels = (userAlertsLevel,level) => {
    const updatedLevels = initialUserLevels ;

    for (let i = 1; i < level; i++) {
      updatedLevels.push  ({ 
        id: (2000+(1000*i)),
        role: `Maintenance Level ${i + 1}`, 
        alertLevel: "" 
      })
    }
    updatedLevels.forEach(level => {
    level.alertLevel = userAlertsLevel[level.id] || 0;
    }); 
    console.log(updatedLevels)
    setUserLevels(updatedLevels);
      }
      const updateMaintainLevels = (userLevels,level) => {
    let updatedLevels = userLevels ;
    console.log()

    if(maintenanceUserLevelCount<level){
    for (let i = 1; i <level; i++) {
      updatedLevels.push  ({ 
        id: (2000+(1000*i)),
        role: `Maintenance Level ${i + 1}`, 
        alertLevel: "" 
      })
    }
    console.log('levels updated',updatedLevels)
    }
        
    else if(maintenanceUserLevelCount>level){
    const excludeIds = Array.from({ length: 5 - level }, (_, i) => 6000 - i * 1000);
    const filteredLevels = userLevels.filter(
      u => !excludeIds.includes(u.id) // keep only those NOT in excludeIds
    );
    updatedLevels=filteredLevels
    }

    console.log(updatedLevels)
    setUserLevels(updatedLevels);
      }
  const renderUserLevelPopup = () => {
    const [maintenanceLevel,setMaintenanceLevel]=useState(maintenanceUserLevelCount);
    if (!showUserLevelPopup) return null;

    return (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}>
        <div style={{
          backgroundColor: "white",
          borderRadius: "2px",
          width: "515px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}>
          {/* Popup Header */}
          <div style={{
            backgroundColor: "#ffff",
            padding: "16px",
            borderBottom: "1px solid #e2e8f0",
            fontSize: "16px",
            fontWeight: 600,
            color: "#1e293b",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <span>Edit User Level</span>
            <button 
              onClick={() => setShowUserLevelPopup(false)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "18px",
                color: "#1e293b",
              }}
            >
              ×
            </button>
          </div>
          
          {/* Popup Content */}
          <div style={{ padding: "16px" }}>
            <div style={{ 
              marginBottom: "16px",
              fontSize: "14px",
              color: "#1e293b",
            }}>
              No of Maintenance User Level
            </div>
            
            <select
              value={maintenanceLevel}
              onChange={(e)=>setMaintenanceLevel(parseInt(e.target.value))}
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
                fontSize: "14px",
                marginBottom: "16px",
                cursor: "pointer",
                outline: "none",
                appearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                backgroundPosition: "right 8px center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "16px",
                paddingRight: "32px",
              }}
            >
              {maintenanceLevels.map((level) => (
                <option key={level} value={level}>
                  Level {level}
                </option>
              ))}
            </select>
          </div>
          
          {/* Popup Footer */}
          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "12px 16px",
          }}>
            <button
              onClick={() => {
                handleUpdateMaintainUserLevel(maintenanceLevel)
                setShowUserLevelPopup(false);
              }}
              style={{
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderAlertLevelPopup = () => {
    const [alertLevel,setAlertLevel]=useState(alertLevelCount);
    if (!showAlertLevelPopup) return null;

    return (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}>
        <div style={{
          backgroundColor: "white",
          borderRadius: "2px",
          width: "515px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}>
          {/* Popup Header */}
          <div style={{
            backgroundColor: "#ffff",
            padding: "16px",
            borderBottom: "1px solid #e2e8f0",
            fontSize: "16px",
            fontWeight: 600,
            color: "#1e293b",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <span>Edit Alert Level</span>
            <button 
              onClick={() => setShowAlertLevelPopup(false)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "18px",
                color: "#1e293b",
              }}
            >
              ×
            </button>
          </div>
          
          {/* Popup Content */}
          <div style={{ padding: "16px" }}>
            <div style={{ 
              marginBottom: "16px",
              fontSize: "14px",
              color: "#1e293b",
            }}>
              No of Alert Level
            </div>
            
            <select
              value={alertLevel}
              onChange={(e)=>setAlertLevel(parseInt(e.target.value))}
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
                fontSize: "14px",
                marginBottom: "16px",
                cursor: "pointer",
                outline: "none",
                appearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                backgroundPosition: "right 8px center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "16px",
                paddingRight: "32px",
              }}
            >
              {alertLevelOptions.map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))}
            </select>
          </div>
          
          {/* Popup Footer */}
          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "12px 16px",
          }}>
            <button
              onClick={() => {
                handleSetAlertLevelCount(alertLevel)
                setShowAlertLevelPopup(false);
              }}
              style={{
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderProjectConfiguration = () => (
    <>
      {/* Top section - User Levels and Alert Levels side-by-side */}
      <div style={{ display: "flex", gap: "20px" ,justifyContent: "flex-end"}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              fontSize: "12px",
              color: "#324054",
              width: "40%",
              height: "36px",
            }}
          >
            Project Name
          </div>
          <select
            value={projectId}
            onChange={(e) =>
              handleProjectSelect( e.target.value)
            }
            style={{
              width: "60%",
              height: "36px",
              padding: "8px 6px",
              marginBottom: "8px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              fontSize: "14px",
              backgroundColor: "white",
              outline: "none",
              // 👇 NEW: limit dropdown height
              maxHeight: "200px", // fits ~6-7 items
              overflowY: "auto",
              maxWidth:"450px"
            }}
          >
            <option value="" disabled hidden>
              Select Project
            </option>
            {projectsForUser.map((project) => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
      </div>
       <div className="grid-container">
      <div style={{ backgroundColor: "white", border: "1px solid #e2e8f0", overflow: "hidden" }}>
        {/* Header Row */}
        <div style={{ display: "flex", backgroundColor: "#e2e5ed", borderBottom: "1px solid #e2e8f0" }}>
          <div 
            style={{ 
              padding: "10px 16px", 
              fontSize: "12px", 
              fontWeight: 600, 
              color: "#324054", 
              textTransform: "uppercase", 
              letterSpacing: "0.5px",
              cursor: "pointer",
              width:"50%",
            }}
            onClick={() => setShowUserLevelPopup(true)}
          >
            MAINTENANCE USER LEVELS - {maintenanceUserLevelCount}
            <i className="far fa-edit" style={{ fontSize: "14px", marginLeft: "8px" }}></i>
          </div>
          <div 
            style={{ 
              padding: "10px 16px", 
              fontSize: "12px", 
              fontWeight: 600, 
              color: "#324054", 
              textTransform: "uppercase", 
              letterSpacing: "0.5px",
              cursor: "pointer",
              width:"50%",
            }}
            onClick={() => setShowAlertLevelPopup(true)}
          >
            ALERT LEVELS - {alertLevelCount}
            <i className="far fa-edit" style={{ fontSize: "14px", marginLeft: "8px" }}></i>
          </div>
        </div>

        {/* Data Rows */}
        {userLevels.map((userLevel) => (
          <div key={userLevel.id} style={{ display: "flex", borderBottom: "1px solid #f1f5f9" ,justifyContent:"space-between"}}>
            {/* User Type Label */}
            <div style={{ padding: "12px 16px", fontSize: "14px", color: "#324054", display: "flex", alignItems: "center" ,width:isMobile?"50%":"auto"}}>
              {userLevel.role}
            </div>

            {/* Alert Level Selector */}
            <div style={{ padding: "8px 16px", display: "flex",width: isMobile ? "50%" : "auto", alignItems: "center" }}>
              <select
                value={userLevel.alertLevel}
                onChange={(e) => handleUserLevelChange(userLevel.id, e.target.value)}
                style={{
                  width: isMobile ? "100%" : "160px",
                  height: "36px",
                  padding: "8px 8px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  backgroundColor: "white",
                  color: "#324054",
                  cursor: "pointer",
                  outline: "none",
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                  backgroundPosition: "right 8px center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "16px",
                  paddingRight: "32px",
                }}
              >
                <option key={0} value={0}>
                  None
                </option>
                  {Array.from({ length: alertLevelCount }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {`Alert Level ${i + 1}`}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom section - Settings */}
      {authService.isSystemAdmin() && (
          <div style={{ backgroundColor: "white", border: "1px solid #e2e8f0", overflow: "hidden" }}>

          {/* Header */}
          <div style={{ backgroundColor: "#e2e5ed", padding: "10px 16px", fontSize: "12px", fontWeight: 600, color: "#324054", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            ADVANCED SETTING
          </div>

          {/* Grid container for 3 vertical columns */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr 40px 40px" : "1fr 80px 80px",
              padding: "16px",
              gap: "20px",
              alignItems: "center",
            }}
          >
            {/* Column 1: Labels */}
            <div style={{ display: "flex", flexDirection: "column", gap: "30px", fontSize: isMobile ? "11px" : "14px", color: "#334155" }}>
              <div>Data Interval <span style={{ fontSize: "10px", color: "#ef4444" }}> (Will Overwrite Each Entity's Settings)</span></div>
              <div>Offline Alert After</div>
              <div>Max Continues Alerts</div>
            </div>

            {/* Column 2: Inputs */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <input
                type="text"
                placeholder=""
                value={advancedSettings.dataInterval}
                onChange={(e) => handleAdvancedSettingChange("dataInterval", e.target.value)}
                style={{
                  width: isMobile ? "40px" : "80px",
                  height: "32px",
                  padding: "6px 8px",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  textAlign: "center",
                }}
              />
              <input
                type="text"
                placeholder=""
                value={advancedSettings.offlineAlertAfter}
                onChange={(e) => handleAdvancedSettingChange("offlineAlertAfter", e.target.value)}
                style={{
                  width: isMobile ? "40px" : "80px",
                  height: "32px",
                  padding: "6px 8px",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  textAlign: "center",
                }}
              />
              <input
                type="text"
                placeholder=""
                value={advancedSettings.maxContinuesAlerts}
                onChange={(e) => handleAdvancedSettingChange("maxContinuesAlerts", e.target.value)}
                style={{
                  width: isMobile ? "40px" : "80px",
                  height: "32px",
                  padding: "6px 8px",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  textAlign: "center",
                }}
              />
            </div>

            {/* Column 3: Units */}
            <div style={{ display: "flex", flexDirection: "column", gap: "30px", fontSize:isMobile ? "11px" : "14px", color: "#64748b" }}>
              <div>Mins</div>
              <div>Intervals</div>
              <div>Times</div>
            </div>
          </div>


      </div>)}
      </div>
      {/* Save button at the bottom */}
        <div style={{ 
          display: "flex", 
          justifyContent: "flex-end", 
          marginTop: "6px",
          paddingTop: "10px",
        }}>
          <button
            onClick={handleSave}
            style={{
              backgroundColor: "#2A7CED",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "10px 24px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              transition: "background-color 0.2s ease",
            }}
          >
            Save
          </button>
        </div>
    </>
  );
  const canShowTab = (tab) => {
    console.log('checking permisions ',authService.hasProjectManagementAccess())
  if (tab === "Project Configuration") {
    return authService.hasProjectManagementAccess();
  }

  if (tab === "Kits Configuration") {
    return true;
  }

  return true;
};


  return (
    <div className="container-react">
      {renderUserLevelPopup()}
      {renderAlertLevelPopup()}
        {/* Header with tabs */}
        <div className="header">
          <nav style={{ display: "flex", borderBottom: "1px solid #e2e8f0",width:"100%"}}>
            {tabs.filter(canShowTab).map((tab) => (
              
              <button
                key={tab}
                onClick={() => handleChangeActiveTab(tab)}
                style={{
                  padding: "4px 4px",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: activeTab === tab ? "#2563eb" : "#64748b",
                  backgroundColor: "transparent",
                  border: "none",
                  borderBottom: activeTab === tab ? "2px solid #2563eb" : "2px solid transparent",
                  cursor: "pointer",
                  width:"50%",
                  transition: "all 0.2s ease",
                  position: "relative",
                }}
              >
                {tab}
              </button>
            ))}
          </nav>
        </div>

        {/* Main content */}
        {activeTab === "Project Configuration" && renderProjectConfiguration()}
        {activeTab === "Kits Configuration" && <KitsConfiguration />}
        <Toaster open={openToaster} isSuccess={success} msg={msg}/>
        {loading && <Loader isLoading={loading} fullScreen={true}/>}
      </div>
    
  );
}